// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".my-form-item-group{width:100%}.my-form-item-group .form-item-group_title{background-color:#edf3fa;border-bottom:1px solid #e8e8e8;border-right:1px solid #e8e8e8;color:#606266;font-weight:700;line-height:32px;padding:0 1em}.my-form-item-group .form-item-group_title:before{content:\"◆\";margin-right:.5em}.my-form-item-group .form-item-group_body{display:flex;flex-wrap:wrap;position:relative;width:100%}.my-form-item-group .form-item-group_body:after{border-right:1px solid #e8e8e8;content:\"\";display:block;height:100%;position:absolute;right:0;top:0;width:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryColor": "#4988cf",
	"primaryColor9": "#5b94d4",
	"primaryColor8": "#6da0d9",
	"primaryColor7": "#80acdd",
	"primaryColor6": "#92b8e2",
	"primaryColor5": "#a4c4e7",
	"primaryColor4": "#b6cfec",
	"primaryColor3": "#c8dbf1",
	"primaryColor2": "#dbe7f5",
	"primaryColor1": "#edf3fa",
	"successColor": "#67c23a",
	"successColor9": "#e1f3d8",
	"successColor8": "#f0f9eb",
	"warningColor": "#e6a23c",
	"warningColor9": "#faecd8",
	"warningColor8": "#fdf6ec",
	"dangerColor": "#f56c6c",
	"dangerColor9": "#fde2e2",
	"dangerColor8": "#fef0f0",
	"infoColor": "#909399",
	"infoColor9": "#e9e9eb",
	"infoColor8": "#f4f4f5",
	"navBgColor": "#304156",
	"navTextColor": "#bfcbd9",
	"navTextActiveColor": "#ffd04b",
	"typefaceColor": "#233b72"
};
module.exports = ___CSS_LOADER_EXPORT___;
